<template>
  <section class="section">
    <div class="container items-center">
      <h3 class="section__h3 mb-5">Let's schedule a personalized demo?</h3>
      <p class="section__p mb-base">We’d be delighted to show you how ALEX can help you achieve your Learning and Development goals. Our L&D consultants will personalize the presentation so it’s focussed on how we can help you achieve your goals.</p>
      <vs-button class="mb-base" color="#dc0032">Schedule a Demo</vs-button>
      <vs-row class="container personality-row" vs-type="flex">
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-justify="center" vs-align="center">
          <img src="../../../../../src/assets/images/pages/alex/demo1.png" width="100%" height="auto"/>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-justify="center" vs-align="center">
          <img src="../../../../../src/assets/images/pages/alex/demo2.png" width="100%" height="auto"/>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
  export default {
    name: "Demo",
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #F7F8F9;
  }

  button {
    border-radius: 50px;
  }

  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: center;
    color: #231D4F;
  }
  .section__p {
    width: 65%;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    /* or 150% */
    text-align: center;
    color: #848199;
  }

  .con-vs-card >>> .vs-card--content {
    padding: 0! important;
  }

  .about-title {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 52px;
    text-transform: capitalize;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 20px;
  }

  .about-desc p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 0px 20px;
  }

  .alex-title {
    background-color: rgba(68,204,136,0.1);
    font-style: normal;
    font-weight: 600;
    font-size: 38px;
    line-height: 115%;
    text-transform: uppercase;
    color: #44CC88;
  }

  .alex-content div {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    display: flex;
    align-items: center;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 15px;
  }

  .alex-content p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 0px 15px;
  }

  .feature-title {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 38px;

    flex: none;
    order: 0;
    align-self: flex-start;
    flex-grow: 0;
    margin: 0px 0px;
    color: #231D4F;
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 20px;

    flex: none;
    order: 1;
    align-self: flex-start;
    flex-grow: 0;
    color: #848199;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 0;
      background: #FFFFFF;
    }
    .section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .leaf {
      width: -webkit-fill-available;
      width: -moz-available;
    }

  }
</style>
